



















import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { User } from "@/models/user";
import { RootState } from "@/store";

@Component({
  components: {
    Avatar
  },
  computed: {
    ...mapState({
      user: (state: any) => state.session.user
    })
  }
})
export default class Avatar extends Vue {
  initials: string = "";
  style: any = "";
  user!: User;

  @Prop({ default: "50" }) private avatar_size!: string;
  @Prop({ default: null }) private avatar_image!: string;
  @Prop({ default: "transparent" }) private bg_color!: string;
  @Prop({ default: false }) private has_badge!: boolean;
  @Prop({ default: false }) private empty_avatar!: boolean;

  mounted() {
    this.getInitials();
    this.style = { "background-color": `${this.bg_color}` };
  }
  getInitials() {
    if (this.user)
      this.initials =
        this.user.firstName.substring(0, 1) +
        this.user.lastName.substring(0, 1);
  }
}
